import { createFileRoute } from '@tanstack/react-router'
import { TimesheetHistory } from '@/common/components/timesheet-history/TimesheetHistory'
import { Navbar } from '@/common/components/navbar'

export const Route = createFileRoute('/history')({
  component: () => (
    <>
      <Navbar />
      <TimesheetHistory />
    </>
  ),
})
